export { imageSelectors } from './image.style.js';

const ImageComponentSelector = "image-component";

export { ImageComponentSelector };
//# sourceMappingURL=index.selectors.js.map
